<template>
    <v-app>
        <login v-if="!token" />
        <frame v-else :style="{ backgroundColor: theme.pageBgColor }" />
        <!-- 交互弹出框 -->
        <pop-up />
    </v-app>
</template>

<script>
import Login from "@/views/Login";
// import Login from "@/views/DataV/Login";
import Frame from "@/views/Frame";
import PopUp from "@/components/PopUp";
import util from "@/util";
import store from "@/store";
import Public from "@/public";
import { mapState } from "vuex";

export default {
    name: "App",
    components: {
        Login,
        Frame,
        PopUp,
    },
    mounted() {
        console.log();
        // 检测断网
        window.addEventListener("offline", () => {
            console.log("已断网");
            util.ShowTip("网络连接失败，请检查网络", 2);
            // this.$router.push("/404");
        });
        window.addEventListener("online", () => {
            console.log("网络已连接");
        });
    },
    created() {
        let user = JSON.parse(localStorage.getItem("user"))
        let theme = JSON.parse(localStorage.getItem("theme"));
        let navigationMode = localStorage.getItem("navigationMode");
        if (user) {
            // let timeDifference = new Date().getTime() - user.last_login * 1000;
            // if (timeDifference >= 1000 * 60 * 60 * 24) {
            //     store.commit("LOG_OUT");
            //     let account = Public.decrypt(localStorage.getItem("account"));
            //     delete account.password;
            //     let accountData = Public.encrypt(account);
            //     localStorage.setItem("account", accountData);
            //     return;
            // } else {
            //     store.commit("USER_UPDATE", user);
            // }
            store.commit("USER_UPDATE", user);
        }
        if (theme) {
            store.commit("SET_THEME", theme);
        }
        if (navigationMode) {
            store.commit("SET_NAVIGATION_MODE", navigationMode);
        }
    },
    computed: {
        ...mapState(["token", "theme", "navigationMode"]),
    },
};
</script>
